import { Box, Divider } from "@mui/material";
import Header from "components/Header";
import React from "react";
import { useSearchParams } from "react-router-dom";
import CarDetailsCard from "./CarDetailsCard";
import CustomerDetails from "./CustomerDetails";
import Loader from "components/Loader";

const InitiateTransactionComponent = () => {
  // get carId from url

  const [searchParams] = useSearchParams();
  const carId = searchParams.get("id");
  const [showLoader, setShowLoader] = React.useState(false);

  function setLoader(value) {
    setShowLoader(value);
  }

  if (showLoader) {
    return <Loader />;
  }

  return (
    <>
      <Box m="1.5rem 2.5rem">
        <Header title={`Initiate Transaction `} />
        <CarDetailsCard carId={carId} />
        <br />
        <Divider />
        <br />
        <div>
          <CustomerDetails carId={carId} setLoader={setLoader} />
        </div>
      </Box>
    </>
  );
};

export default InitiateTransactionComponent;
